const Layout = () => import('@/layout/index.vue')

export default  {
    meta: {
        title: '店铺管理',
        icon: 'sidebar-default'
    },
    children: [{
        path: '/shop',
        component: Layout,
        redirect: '/shop/index',
        isLogin: false,
        meta: {
            title: '店铺管理',
            icon: 'spgl',
            isShowIcon: true
        },
        children: [
            {
                path: 'index',
                name: 'ShopIndex',
                component: () => import('@/views/shop/index.vue'),
                meta: {
                    title: '店铺管理',
                    icon: 'merchant-account',
                    sidebar: false,
                    breadcrumb: false
                }
            }
        ]
    }]
}
